import React from 'react';
import ReactDOM from 'react-dom';
import './FullScreenModal.css';

function FullScreenModal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal-overlay-fullscreen" onClick={onClose}>
      <div className="modal-content-fullscreen" onClick={e => e.stopPropagation()}>
        {children}
        <button className="close-button" onClick={onClose}>閉じる</button>
      </div>
    </div>,
    document.body
  );
}

export default FullScreenModal;